
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./serial.resolver.cjs.production.min.js')
} else {
  module.exports = require('./serial.resolver.cjs.development.js')
}
